import { ReactHookFc } from 'src/components/common/ReactHookForm'
import React from 'react'
import { SelfRegUpdatePageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponUpdatePage'
import styled, { css } from 'styled-components'
import { Noto_body1_r16, Noto_body2_m14, Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'
import { useFormContext } from 'react-hook-form'
import { SelfRegisterCouponFormItemsType } from 'src/types/react-hook-form'

const SelfRegCommonFormItems = ({
  registerAttribute,
}: Pick<SelfRegUpdatePageProps, 'registerAttribute'>) => {
  const { couponName, brandName, barcode, memo, validDate } = registerAttribute
  const {
    formState: { errors = {} },
  } = useFormContext<SelfRegisterCouponFormItemsType>()
  const {
    barcode: { message: barcodeErrMsg } = {},
    validDate: { message: validDateErrMsg } = {},
    couponName: { message: couponNameErrMsg } = {},
    brandName: { message: brandNameErrMsg } = {},
    memo: { message: memoErrMsg } = {},
  } = errors

  return (
    <React.Fragment>
      <ReactHookFc.Input
        {...barcode}
        style={S.InputStyle}
        topChildren={<S.FormItemTitle $text="바코드" />}
        bottomChildren={<S.FormErrorMsg $text={barcodeErrMsg} />}
      />
      <ReactHookFc.DatePicker
        {...validDate}
        style={S.InputStyle}
        topChildren={<S.FormItemTitle $text="유효기간" />}
        bottomChildren={<S.FormErrorMsg $text={validDateErrMsg} />}
      />
      <ReactHookFc.Input
        {...couponName}
        style={S.InputStyle}
        topChildren={<S.FormItemTitle $text="쿠폰상품명" />}
        bottomChildren={<S.FormErrorMsg $text={couponNameErrMsg} />}
      />
      <ReactHookFc.Input
        {...brandName}
        style={S.InputStyle}
        topChildren={<S.FormItemTitle $text="브랜드(선택)" />}
        bottomChildren={<S.FormErrorMsg $text={brandNameErrMsg} />}
      />
      <ReactHookFc.TextArea
        {...memo}
        style={S.TextAreaStyle}
        topChildren={<S.FormItemTitle $text="메모(선택)" />}
        bottomChildren={<S.FormErrorMsg $text={memoErrMsg} />}
      />
    </React.Fragment>
  )
}
export default SelfRegCommonFormItems

const S = {
  InputStyle: css`
    width: 100%;
    border-radius: 12px;
    background: var(--white);
    border: 1px solid var(--black-20);
    color: var(--black-90);
    ${Noto_body1_r16};
    height: 48px;
    padding: 12px 16px;
    &::placeholder {
      color: var(--black-40);
    }
  `,
  TextAreaStyle: css`
    border-radius: 12px;
    padding: 12px 16px;
    border: 1px solid var(--black-20);
    background: var(--white);
    height: 120px;

    ${Noto_body1_r16};
    color: var(--black-90);
    &::placeholder {
      color: var(--black-40);
    }
  `,
  FormItemTitle: styled.span<{ $text: string }>`
    ${Noto_body2_m14};
    color: var(--black-50);

    &:before {
      content: '${(props) => props.$text}';
    }
  `,
  FormErrorMsg: styled.span<{ $text?: string }>`
    display: ${(props) => (!!props.$text ? 'flex' : 'none')};
    ${Noto_body2_r14};
    color: var(--red-50);
    &:before {
      content: '${(props) => props.$text}';
    }
  `,
}
